// Date example
import { StringCompare } from "@stamhoofd/utility";
import { Filter, FilterDefinition } from "./FilterDefinition";
export class StringFilterDefinition extends FilterDefinition {
    decode(data) {
        var _a, _b, _c, _d;
        const filter = new StringFilter();
        filter.definition = this;
        filter.value = (_b = (_a = data.optionalField("value")) === null || _a === void 0 ? void 0 : _a.string) !== null && _b !== void 0 ? _b : "";
        filter.mode = (_d = (_c = data.optionalField("mode")) === null || _c === void 0 ? void 0 : _c.enum(StringFilterMode)) !== null && _d !== void 0 ? _d : StringFilterMode.Contains;
        return filter;
    }
    createFilter() {
        const filter = new StringFilter();
        filter.definition = this;
        return filter;
    }
}
export var StringFilterMode;
(function (StringFilterMode) {
    StringFilterMode["Contains"] = "Contains";
    StringFilterMode["Equals"] = "Equals";
    StringFilterMode["NotContains"] = "NotContains";
    StringFilterMode["NotEquals"] = "NotEquals";
    StringFilterMode["NotEmpty"] = "NotEmpty";
    StringFilterMode["Empty"] = "Empty";
})(StringFilterMode || (StringFilterMode = {}));
export class StringFilter extends Filter {
    constructor() {
        super(...arguments);
        this.value = "";
        this.mode = StringFilterMode.Contains;
    }
    doesMatch(object) {
        const str = this.definition.getValue(object);
        if (this.mode === StringFilterMode.Contains) {
            return StringCompare.contains(str, this.value);
        }
        if (this.mode === StringFilterMode.NotContains) {
            return !StringCompare.contains(str, this.value);
        }
        if (this.mode === StringFilterMode.Equals) {
            return StringCompare.typoCount(str, this.value) == 0;
        }
        if (this.mode === StringFilterMode.NotEquals) {
            return StringCompare.typoCount(str, this.value) != 0;
        }
        if (this.mode === StringFilterMode.NotEmpty) {
            return str != "";
        }
        if (this.mode === StringFilterMode.Empty) {
            return str == "";
        }
        return false;
    }
    encode(context) {
        return {
            definitionId: this.definition.id,
            value: this.value,
            mode: this.mode
        };
    }
    toString() {
        if (this.definition.explainFilter) {
            return this.definition.explainFilter(this);
        }
        if (this.mode === StringFilterMode.Contains) {
            return this.definition.name + " bevat " + this.value;
        }
        if (this.mode === StringFilterMode.NotContains) {
            return this.definition.name + " bevat niet " + this.value;
        }
        if (this.mode === StringFilterMode.Equals) {
            return this.definition.name + " is gelijk aan " + this.value;
        }
        if (this.mode === StringFilterMode.NotEquals) {
            return this.definition.name + " is niet gelijk aan " + this.value;
        }
        if (this.mode === StringFilterMode.NotEmpty) {
            return this.definition.name + " is niet leeg";
        }
        if (this.mode === StringFilterMode.Empty) {
            return this.definition.name + " is leeg";
        }
        return "Onbekend";
    }
    get inverted() {
        const filter = this.clone();
        if (this.mode === StringFilterMode.Contains) {
            filter.mode = StringFilterMode.NotContains;
        }
        else if (this.mode === StringFilterMode.NotContains) {
            filter.mode = StringFilterMode.Contains;
        }
        else if (this.mode === StringFilterMode.Equals) {
            filter.mode = StringFilterMode.NotEquals;
        }
        else if (this.mode === StringFilterMode.NotEquals) {
            filter.mode = StringFilterMode.Equals;
        }
        else if (this.mode === StringFilterMode.NotEmpty) {
            filter.mode = StringFilterMode.Empty;
        }
        else if (this.mode === StringFilterMode.Empty) {
            filter.mode = StringFilterMode.NotEmpty;
        }
        return filter;
    }
}
//# sourceMappingURL=StringFilter.js.map